<template>
  <a
    :class="[customClasses, {'isDisabled': disabled}]"
    :disabled="disabled"
    class="btn-icon"
    @mouseenter="onHover"
    @click="handlerClick($event, disabled, handler)">
    <div class="btn-flex-row">
      <div v-if="!loading" class="btn-flex-item">
        <slot></slot>
      </div>
      <div class="btn-flex-item">
        {{ title }}
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    disabled: [Object, Boolean],
    loading: {type: Boolean, default: false},
    customClasses: String,
    title: String,
    handler: Function,
    onHover: {type: Function, default: () => {}}
  },
  methods: {
    handlerClick(event, disabled, handler) {
      if (disabled) {
        event.preventDefault();
      } else if (handler) {
        handler();
        event.stopPropagation();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-icon {
  .btn-flex-row {
    display: flex;

    align-items: center;
    .btn-flex-item:first-child {
      display: flex;
      align-items: center;
      padding-right: 7px;
    }
  }
  /deep/ .svg-icon {
    stroke: var(--secondary);
  }
  /deep/ .svg-icon.no-stroke {
    stroke: none;
  }
  /deep/ .svg-fill.no-stroke {
    stroke: none;
  }
  &:hover {
    border-color: var(--secondary);
  }
  &.isDisabled {
    .btn-flex-item {
      color: var(--white);
    }
    .svg-icon {
      stroke: var(--white);
    }
  }
}
</style>
